import React from 'react';
import {Patterns} from '../../../../tools/patterns';
import './detail.less';
import '../index.less';

// 表单模块头
export const SalesmanFormTitle = ({title}) => (
    <div className='salesman_edit_form-title'>
        <span/>
        <h1>{title}</h1>
    </div>
)

export const SalesmanHeader = ({text}) => (
    <div className='salesman_edit_form-header'>
        {text}
    </div>
)

// 根据id找到对应树节点的对象
export const findObjById = (id = '', treeData = [], key = '') => {
    let res;
    const findObjByIdNext = (arr) => {
        const index = arr.findIndex(val => (val[key] === id));
        if (index !== -1) {
            res = arr[index];
            return;
        }
        arr.forEach(val => {
            if (val.childrens && val.childrens.length) {
                findObjByIdNext(val.childrens);
            }
        })
    }
    findObjByIdNext(treeData);
    return res || {};
}

// 根据id找到对应树节点的中文名称及id数组
export const findAllObjById = (id = '', treeData = [], key = '', cname = '') => {
    const queue = [];
    const find = (data, value) => {
        for (let i = 0; i < data.length; i++) {
            const childrens = data[i].childrens;
            const id = data[i][key];
            const name = data[i][cname];
            const companyId = data[i].companyId;
            if (id !== value) {
                if (childrens && childrens.length > 0) {
                    if (find(childrens, value)) {
                        queue.unshift({id: companyId, name}); // 非底层取 companyId
                        return true;
                    }
                }
            } else {
                queue.unshift({id, name}); // 团队树底层取groupId
                return true;
            }
        }
    };
    find(treeData, id)
    return queue || [];
}

export const companyManagerHeadquartersTagType = {
    '总部': '0',
    '机构': '1',
    '团队': '2',
    '渠道': '3',
    '0': '总部',
    '1': '机构',
    '2': '团队',
    '3': '渠道'
}

export const CompanyLevelIdType = {
    '10008': '三级机构',
    '10007': '二级机构',
    '10009': '四级机构',
    '10006': '一级机构',
    '10005': '总部',
    '总部': '10005',
    '一级机构': '10006',
    '二级机构': '10007',
    '三级机构': '10008',
    '四级机构': '10009',

}

export const IdentificationType = {
    'Y': '已认证',
    'N': '未认证',
    '已认证': 'Y',
    '未认证': 'N'
}

export const CompanyManagerHeaderTag = ({type}) => (
    <span
        className={'treeIcon ' + ((type === companyManagerHeadquartersTagType.机构||type === companyManagerHeadquartersTagType.渠道) ? 'treeIcon_jg' : type === companyManagerHeadquartersTagType.团队 ? 'treeIcon_td' : 'treeIcon_zb')}>
        {companyManagerHeadquartersTagType[type]}
    </span>
)

// 手机号校验
export const validatePhone = (bool) => ({
    pattern: /^1[3456789]\d{9}$/,
    required: !bool,
    validateTrigger: 'onChange',
    message: '手机号格式不正确',
});

// 邮箱
export const validateEmail = () => ({
    required: false,
    pattern: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
    message: '邮箱格式不正确',
    validateTrigger: 'onChange',
});

export const validateID = (bool) => ({
    required: bool,
    message: '请输入正确的身份证号',
    pattern: Patterns.pattern_cid,
    validateTrigger: 'onChange',
})

export const validateName = (bool) => ({
    required: bool,
    message: '请输入姓名',
    validateTrigger: 'onChange',
})